<template>
<div style="min-height: 100%;">
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 1100px;margin: 0 auto;" >
    <el-steps style="padding-top:15px; width: 1050px; " :active="active" finish-status="success" align-center>
      <el-step title="账户创建" icon="el-icon-user-solid"></el-step>
      <el-step title="基本信息填写" icon="el-icon-s-home"></el-step>
      <el-step title="证照上传" icon="el-icon-picture"></el-step>
      <el-step title="注册完成" icon="el-icon-info"></el-step>
    </el-steps>
    <!--background-color: #f8f8f8;-->
    <div v-if="active===0" class="register-wrapper-div">
      <el-form :disabled="registerInvalid" @submit.native.prevent style="width: 560px; margin: 0 auto;" label-position="right" label-width="150px" key="loginAccount" :rules="loginAccountRules" :model="loginAccount" ref="loginAccount">
          <!-- <el-col :span="24" style="text-align: left; margin: 10px 0 0;">
            <el-alert center :closable="false" type="info"  effect="dark" style="background-color: #9cccdd; margin: 5px 0;">
              <template slot="title">
                <div style="font-size: 16px; font-family: '黑体'; margin: 8px 0">2022年度上海市非免疫规划疫苗集团采购项目企业报名</div>
              </template>
              本次报名已结束!
            </el-alert>
          </el-col> -->
        <h2>&nbsp;</h2>
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginAccount.username" placeholder="由6到14位的中文、字母或数字组成" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码"  prop="password">
          <el-input v-model="loginAccount.password" placeholder="请输入6-20位密码" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码"  prop="checkPass" style="margin-bottom: 10px;">
          <el-input v-model="loginAccount.checkPass" placeholder="请再次输入密码"  autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <p style="text-align: right;">
        <el-link type="primary" :href="`http://www.shgpo.com/member/readflie.jspx?filePath=/u/cms/www/20220306/2203061616tmpt.docx`" target="_blank" style="font-size: 12px;">授权委托书模板下载&nbsp;<i class="el-icon-download" style="font-size: 14px;"></i></el-link>
        </p>
      </el-form>
      <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="goLogin">返回登录</el-button>
      <el-button :loading="submitButtonLoading" type="primary" style="margin: 20px 0;" @click="next('loginAccount')" v-if="!registerInvalid">下一步</el-button>
    </div>

    <div v-if="active===1" class="register-wrapper-div">
      <el-form @submit.native.prevent style="text-align: left; margin: 5px 30px 0px" label-position="right" label-width="150px" key="companyInfo" :rules="companyInfoRules" :model="companyInfo" ref="companyInfo" :disabled="registerInvalid" size="mini">
        <el-row type="flex">
          <el-col :span="24">
            企业信息
            <el-divider></el-divider>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24" style="margin-bottom: 10px;">
            <el-alert title="  进口疫苗代理企业请填写国内代理企业社会统一社会信用代码，企业信息选择「进口药品全国总代理」为‘是’。" left :closable="false" type="warning" effect="dark" style="background-color: #9cccdd;" show-icon>
            </el-alert>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码" prop="zzjgdm">
              <el-input v-model="companyInfo.zzjgdm" placeholder="请输入18位统一社会信用代码" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进口药品全国总代理/药品上市许可持有人" label-width="320px" prop="agent" v-if="companyInfo.companyType === 1">
              <el-radio-group v-model="companyInfo.agent">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="企业名称"  prop="companyName">
              <el-input v-model="companyInfo.companyName" maxlength="200" placeholder="请输入企业名称" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="法定代表人"  prop="attr_qyfrxm">
            <el-input v-model="companyInfo.attr_qyfrxm" placeholder="同营业执照中的法定代表人" autocomplete="off" clearable style="width: 200px"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            被授权人信息
            <el-divider></el-divider>
          </el-col>
        </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="被授权人"  prop="attr_lxr">
                <el-input v-model="companyInfo.attr_lxr" placeholder="请输入被授权人姓名" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="所属部门/职务">
              <el-input v-model="companyInfo.departments" placeholder="请输入被授权人所属部门/职务" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="身份证号" prop="idNumber">
                <el-input v-model="companyInfo.idNumber" placeholder="请输入被授权人身份证号" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="companyInfo.phone" placeholder="请输入被授权人联系电话" autocomplete="off" clearable></el-input>
              </el-form-item>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="companyInfo.email" placeholder="请输入被授权人电子邮箱" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              其他联系人信息
              <el-divider></el-divider>
            </el-col>
          </el-row>
          <el-row type="flex" v-for="(w, index) in companyInfo.contacts" :key="`contacts-` + index">
            <el-col :span="5">
              <el-form-item label="联系人" label-width="70px" :prop="'contacts.' + index + '.lxr'" :rules="{ required: true, message: '联系人姓名不能为空', trigger: 'blur'}">
                <el-input v-model="w.lxr" placeholder="请输入联系人姓名" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="部门/职务" label-width="80px">
                <el-input v-model="w.departments" placeholder="请输入部门/职务" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号" label-width="80px" :prop="'contacts.' + index + '.phone'"
              :rules="[
                { required: true, message: '请输入联系人手机号', trigger: 'blur' },
                {
                  pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                  message: '请输入正确的联系电话'
                }
                ]">
                <el-input v-model="w.phone" placeholder="请输入手机号" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="电子邮箱" label-width="80px" :prop="'contacts.' + index + '.email'"
              :rules="[
                { required: true, message: '请输入联系人电子邮箱', trigger: 'blur' },
                {
                  pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
                  message: '请输入正确的电子邮箱'
                }
                ]">
                <el-input v-model="w.email" placeholder="请输入电子邮箱" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-button type="text" size="mini" style="color: #F56C6C;" @click.prevent="removeContact(w)">&nbsp;删除</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-button plain style="width: 100%" size="mini" @click="addContact">
              <i class="el-icon-plus" /> 新增联系人信息
            </el-button>
          </el-row>
        </el-form>

        <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="previous" v-if="!registerInvalid">上一步</el-button>
        <el-button :loading="submitButtonLoading"  type="primary" style="margin: 20px 0;" @click="next('companyInfo')" v-if="!registerInvalid">下一步</el-button>
      </div>

      <div v-if="active===2" class="register-wrapper-div">
        <el-form @submit.native.prevent style="text-align: left; margin: 5px 50px 0px;" label-position="right" label-width="150px" status-icon key="qyzzUpload" :rules="qyzzUploadRules" :model="qyzzUpload" ref="qyzzUpload" :disabled="registerInvalid">
        <el-row type="flex">
          <el-col :span="24">
            企业资质上传
            <el-divider></el-divider>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24" style="margin-bottom: 10px; ">
            <el-alert center :closable="false" type="info" effect="dark" style="background-color: #9cccdd; font-weight: 400; margin: 5px 0;">
              请将以下材料扫描并制作成一份pdf文件，进行上传：
              <br/>（1）营业执照
              <br/>（2）报名用法定代表人授权委托书或法定代表人证明&emsp;
              <el-link type="primary" :href="`http://www.shgpo.com/member/readflie.jspx?filePath=/u/cms/www/20220306/2203061616tmpt.docx`" target="_blank" style="font-size: 12px;">授权委托书模板下载&nbsp;<i class="el-icon-download" style="font-size: 14px;"></i></el-link>
              <br/>（3）被授权人在本单位的社保缴纳证明（近6个月内任意一个月）
              <br/>（4）投标人是国内疫苗上市许可持有人的，具有有效的《药品生产许可证》
              <br/>（5）制造商为境外疫苗厂商的，应指定一家具有相关资质的国内代理机构作为投标人，投标人应提供《境外疫苗厂商代理机构备案表》或省级及以上药监部门出具的《境外疫苗厂商代理机构备案表》受理通知书，以及有效的《药品经营许可证》、境外疫苗厂商出具的授权委托书复印件及其公证文书、中文译本。
              <template slot="title">
                <div style="font-size: 16px; font-family: '黑体'; margin: 8px 0"></div>
              </template>
            </el-alert>
          </el-col>
        </el-row>
        <el-row type="flex" style="margin-left: 130px;">
          <el-form-item label="附件上传" prop="yyzzImg" >
            <el-upload
              class="upload-left"
              :action="uploadImgUrl"
              :on-preview="handlePreview"
              :before-remove="beforeRemove"
              :on-remove="handleRemoveyyzzImg"
              :multiple="false"
              :limit="1"
              :on-exceed="handleExceed"
              :before-upload="beforeFileUpload"
              :on-success="handleSuccessyyzzImg"
              :on-error="handleError"
              :file-list="fileListyyzzImg"
              >
              <el-button :loading="submitButtonLoading" size="small" type="primary">点我上传附件 (限PDF文件)</el-button>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row type="flex" style="margin: 0 130px;">
          <el-col :span="18">
            <el-form-item label="验证码"  prop="captcha">
              <el-input v-model="qyzzUpload.captcha"
                        placeholder="请输入验证码"
                        autocomplete="off"
                        autocapitalize="off"
                        spellcheck="false"
              ></el-input>
            </el-form-item>
          </el-col>
            <img ref="captcha" style="width: 100px; height: 55px" :src="captchaUrl" @click="changCaptcha" />
        </el-row>
      </el-form>
      <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="previous" v-if="!registerInvalid">上一步</el-button>
      <el-button :loading="submitButtonLoading" type="primary" style="margin: 20px 0;" @click="submitForm('qyzzUpload')" v-if="!registerInvalid">提交</el-button>
    </div>

      <div v-if="active===3" class="register-wrapper-div">
        <el-row type="flex">
          <el-col :span="24">
          <span style="font-size: 75px;font-weight: bold; padding: 20px;line-height: 80px;">
            <i class="el-icon-success" style="color:#52C41A;"></i>
          </span>
          </el-col>
        </el-row>
        <el-row>
          <div style="font-size: 24px; color: #333;font-weight: 500; margin-top: 30px;">
            您的账号已注册成功！
          </div>
          <div>&emsp;</div>
          <div style="font-size: 14px;color: #666; margin: 10px 100px 50px; text-align: center;">
            我们将尽快对您的报名资料予以审核，审核结果及后续操作将以邮件的形式发送至您预留邮箱，请注意查收!
          </div>
        </el-row>
      </div>
    </div>

    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <FooterView></FooterView>
  </div>
</template>
<script>


  export default {
    name: 'producer-register',
    data() {
      var checkPass =(rule, value, callback) => {
        if (value !== this.loginAccount.password) {
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      var zcxyCheck =(rule, value, callback) => {
        if(!value){
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      //统一社会信用代码
      var zzjgdmUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.zzjgdmUnique({'zzjgdm':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //账户名
      var usernameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.usernameUnique2({'username':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //企业名称
      var companyNameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.companyNameUnique2({'companyName':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //验证码
      var captchaUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.captchaValidate({'captcha':value}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              callback();
            }else{
              callback(new Error(response.data.data));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      return {
        active: 0,
        height: 0,
        registerInvalid: false,
        submitButtonLoading: false,
        dialogImageVisible: false,
        dialogPdfVisible: false,
        dialogImageUrl: '',
        dialogPdfUrl: null,
        pdfPage : 1,
        pageCount: 0,
        captchaUrl: '',
        zcxyUrl: '', //注册协议
        uploadImgUrl: '', //图片上传
        companyTypes: [
          {
            value:1,
            label:'生产企业'
          },
          {
            value:2,
            label:'经营企业'
          }
        ],
        loginAccount: {
          //zzjgdm: '', //统一社会信用代码
          username: '', //账户名
          password: '', //密码
          checkPass: '' //确认密码
        },
        companyInfo: {
          zzjgdm: '', //统一社会信用代码
          companyType: 3, //企业注册类型 1、生成企业 2、经营企业 3、疫苗生产企业
          attr_shortName: '', //企业简称
          agent: undefined, //是否进口药品全国总代理
          companyName: '', //企业名称
          attr_qyfrxm: '', //法定代表人
          attr_lxr: '', //联系人(被授权人)
          departments: '', //所属部门和职务
          idNumber: '', //身份证号
          phone: '', //联系电话
          email: '', //电子邮箱
          contacts: []
        },
        qyzzUpload: {
          yyzzImg: '', //营业执照
          ypscImg: '', //药品生产许可证 / 进口药品全国总代理 协议
          ypscImgName: '', //根据agent变化药品生产许可证 / 进口药品全国总代理 协议
          fddbrsqzsImg: '', //法定代表人授权证书
          captcha: '', //验证码
          zcxy: true //注册协议
        },
        fileListyyzzImg:[],
        fileListypscImg:[],
        fileListfddbrsqzsImg:[],
        loginAccountRules: {
          username: [//远程校验唯一
            { required: true, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            { min: 6, max: 14, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            {
              pattern: /(^[a-zA-Z0-9_\u4e00-\u9fa5]+$)/,
              message: "账户名由6到14位的中文字符、英文字母、数字组成"
            },
            { validator:usernameUnique, message: '此账户名已注册', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入6-20位密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,20}/, message: '密码中必须包含大小写字母、数字', trigger: 'blur' },
          ],
          checkPass: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { validator:checkPass, message: '两次输入密码不一致!', trigger: 'blur' }
          ]
        },
        companyInfoRules: {
          zzjgdm: [ //远程校验唯一
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { validator:zzjgdmUnique, message: '统一社会信用代码已注册', trigger: 'blur' }
          ],
          companyType: [
            { required: true, message: '请选择企业注册类型', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' },
            { min: 0, max: 200, message: '最大200个汉字', trigger: 'blur' },
            { validator:companyNameUnique, message: '企业名称已注册', trigger: 'blur' }
          ],
          agent: [
            { required: true, message: '请选择', trigger: 'blur' }
          ],
          attr_qyfrxm: [
            { required: true, message: '请输入法定代表人', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          attr_lxr: [
            { required: true, message: '请输入一位联系人(被授权人)', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          idNumber: [
            { required: true, message: '请输入联系人身份证号', trigger: 'blur' },
            { min: 0, max: 18, message: '最大18位', trigger: 'blur' },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "请输入正确的身份证号"
            }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
              message: "请输入正确的联系电话"
            }
          ],
          email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
        },
        qyzzUploadRules: {
          yyzzImg: [
            { required: true, message: '请上传营业执照', trigger: 'blur' }
          ],
          fddbrsqzsImg: [
            { required: true, message: '请上传法定代表人授权证书', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
          zcxy: [
            { validator:zcxyCheck, message: '请阅读《注册协议》', trigger: 'change' }
          ]
        }
      };
    },
    mounted(){
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350};
    },
    created() {
      this.captchaUrl = this.getCaptchaUrl();
      this.zcxyUrl = process.env.VUE_APP_API_URL + 'member/register_agreement.jspx';
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
    },
    watch:{
      companyInfo:{
        handler(val, oldVal){
          if(1 === val.companyType){
            this.qyzzUpload.ypscImgName = val.agent === 0?'药品生产许可证':'进口药品全国总代理协议/药品上市许可持有人资质证明';
          }else if(2 === val.companyType){
            this.qyzzUpload.ypscImgName = '药品经营许可证';
          }
          let qyzzUploadRulesTemp = {
            ypscImg: [
              { required: true, message: "请上传"+this.qyzzUpload.ypscImgName, trigger: 'blur' }
            ]
          };
          Object.assign(this.qyzzUploadRules, qyzzUploadRulesTemp);
        },
        deep: true //true 深度监听
      }
    },
    methods: {
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.qyzzUpload.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      previous() {
        console.log(this.fileListyyzzImg, this.loginAccount, this.companyInfo, this.qyzzUpload);
        if (this.active-- < 0) this.active = 0;
      },
      next(formName) {
        console.log(this.fileListyyzzImg, this.loginAccount, this.companyInfo, this.qyzzUpload);
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitButtonLoading =  false;
            if (this.active++ > 4) this.active = 0;
          } else {
            this.submitButtonLoading =  false;
            return false;
          }
        });
      },
      submitForm(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //dosubmit
            console.log(this.loginAccount,this.companyInfo,this.qyzzUpload);
            //扁平化其他联系人
            const _contact = Object.assign({});
            if(0 < this.companyInfo.contacts.length){
              this.companyInfo.contacts.forEach((w, i) => {
                if(w.lxr){
                  _contact['attr_lxr' + (1 + i)] = w.lxr
                }
                if(w.departments){
                  _contact['attr_departments' + (1 + i)] = w.departments
                }
                if(w.phone){
                  _contact['attr_phone' + (1 + i)] = w.phone
                }
                if(w.email){
                  _contact['attr_email' + (1 + i)] = w.email
                }
              })
            }
            // var json3 = JSON.parse((JSON.stringify(this.loginAccount) + JSON.stringify(this.companyInfo) + JSON.stringify(this.qyzzUpload)).replaceAll('}{', ','));
            var json3={};
            const _companyInfo = {...this.companyInfo}
            Object.assign(json3, this.loginAccount, _companyInfo, this.qyzzUpload, _contact);
            this.$api.registerApi.doRegisterVaccine(json3).then(response => {
              this.submitButtonLoading = false;
              console.log(response);
              if(response.status === 200){
                if(response.data.code === 200){
                  if (this.active++ > 4) this.active = 0;
                }else{
                  this.captchaUrl = this.getCaptchaUrl();
                  this.$message.error({message:response.data.data || `服务忙，请稍后再试`});
                }
              }else{
                this.captchaUrl = this.getCaptchaUrl();
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.captchaUrl = this.getCaptchaUrl();
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
            return false;
          }
        });
      },
      addContact(){
        this.companyInfo.contacts.push({lxr: '', departments: '', phone: '', email: ''})
      },
      removeContact(item) {
        var index = this.companyInfo.contacts.indexOf(item)
        if (index !== -1) {
          this.companyInfo.contacts.splice(index, 1)
        }
      },
      goLogin() {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL
        // this.$router.push({path: +''});
      },
      handleRemoveyyzzImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.yyzzImg = '';
        this.fileListyyzzImg = fileList.slice(0,0);
      },
      handleRemoveypscImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.ypscImg = '';
        this.fileListypscImg = fileList.slice(0,0);
      },
      handleRemovefddbrsqzsImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.fddbrsqzsImg = '';
        this.fileListfddbrsqzsImg = fileList.slice(0,0);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        this.dialogPdfUrl = fileUrl;
        window.open(fileUrl);
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        //const supportFileType = ["jpg", "jpeg", "gif", "png", "bmp","pdf"];
        // const supportFileType = ['rar','zip','pdf'];
        const supportFileType = ['pdf'];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      handleSuccessyyzzImg(response, file, fileList) {
        if(response.code === 200){
          this.qyzzUpload.yyzzImg = response.data;
          this.fileListyyzzImg = fileList;
        }else{
          this.$message.error(response.msg);
          this.fileListyyzzImg = fileList.slice(0,0);
        }
      },
      handleSuccessypscImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.ypscImg = response.data;
          this.fileListypscImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListypscImg = fileList.slice(0,0);
        }
      },
      handleSuccessfddbrsqzsImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.fddbrsqzsImg = response.data;
          this.fileListfddbrsqzsImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListfddbrsqzsImg = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //关闭窗口初始化PDF页码
      closePdfDialog(){
        this.pdfPage = 1;
        this.dialogPdfVisible = false;
      },
      //PDF改变页数
      previousPdfPage(){
        var p = this.pdfPage
        p = p>1?p-1:this.pageCount
        this.pdfPage = p
      },
      nextPdfPage(){
        var p = this.pdfPage
        p = p<this.pageCount?p+1:1
        this.pdfPage = p
      }
    }
  }
</script>
<style>
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }
  .register-wrapper-div{
    text-align: center;
    padding-top:10px;
    width: 950px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-alert .el-alert__description{
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Register/ProducerRegister.vue